(() => {
  const form = document.querySelector('form[id^="RevvyForm-"]');
  if (!form || form.dataset.teamReady) return;
  form.dataset.teamReady = 'true';
  form.noValidate = true;
  const root = form.closest('.revvy-configurator');
  const q = s => root.querySelector(s);
  const config = JSON.parse(q('[data-team-config]').textContent);
  const t = config.strings;
  const cartRoot = config.cartRoot;
  const submit = form.querySelector('[type="submit"]');
  const add = q('[data-team-save]');
  const status = q('[data-team-status]');
  const storageStatus = q('[data-team-storage]');
  const style = q('[data-badge-style]');
  const productStyle = style.value, productVariant = style.dataset.variant, productUrl = style.dataset.productUrl;
  const photo = q('[data-revvy-file="photo"]');
  const logo = q('[data-revvy-file="logo"]');
  const company = form.elements.namedItem('properties[Company Name]');
  const review = form.elements.namedItem('properties[Google Review Link]');
  const personal = ['first', 'last', 'display', 'title'].map(k => q(`[data-revvy-input="${k}"]`));
  let state = { version: 1, team: [], current: null, editing: null, attempted: false };
  let busy = false, restoring = true, timer, revision = 0, db, persistenceFailed = false;
  let writes = Promise.resolve();
  const uid = () => crypto.randomUUID();
  const setStatus = value => { status.textContent = value; };
  const notifyInput = el => el.dispatchEvent(new Event('input', { bubbles: true }));
  const setFile = (input, file) => {
    const transfer = new DataTransfer();
    if (file) transfer.items.add(file instanceof File ? file : new File([file], input === logo ? 'company-logo.png' : 'technician-photo.jpg', { type: file.type }));
    input.files = transfer.files;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };
  const properties = () => Object.fromEntries([...form.elements].filter(el => el.name?.startsWith('properties[') && el.type !== 'file').map(el => [el.name, el.value]));
  const snapshot = () => ({ props: properties(), variant: productVariant, productUrl, logo: logo.files[0] || null, photo: photo.files[0] || null, crop: form.revvyGetCrop() });
  const hasPerson = () => personal.some(el => el.value.trim()) || !!photo.files[0];
  function updateStyle() {
    style.value = productStyle;
    form.elements.namedItem('id').value = productVariant;
  }
  updateStyle();
  const openDatabase = () => new Promise((resolve, reject) => {
    const request = indexedDB.open('revvytag-team-builder', 1);
    request.onupgradeneeded = () => request.result.createObjectStore('drafts');
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
    request.onblocked = () => reject(new Error('Storage blocked'));
  });
  const storage = (operation, value) => new Promise((resolve, reject) => {
    const tx = db.transaction('drafts', operation === 'get' ? 'readonly' : 'readwrite');
    const store = tx.objectStore('drafts');
    const request = operation === 'get' ? store.get('team-v1') : operation === 'delete' ? store.delete('team-v1') : store.put(value, 'team-v1');
    tx.oncomplete = () => resolve(request.result);
    tx.onerror = () => reject(tx.error);
    tx.onabort = () => reject(tx.error);
  });
  function persist(current = snapshot()) {
    if (restoring) return writes;
    state.current = current;
    const saved = structuredClone(state);
    writes = writes.then(async () => {
      if (!db) throw new Error('Storage unavailable');
      await storage('put', saved);
      persistenceFailed = false;
      storageStatus.textContent = t.saved;
    }).catch(() => { persistenceFailed = true; storageStatus.textContent = t.storage_error; });
    return writes;
  }
  function autosave() {
    if (restoring) return;
    revision++;
    if (busy) return;
    clearTimeout(timer);
    timer = setTimeout(persist, 250);
  }
  form.addEventListener('input', autosave);
  form.addEventListener('change', autosave);
  for (const event of ['pointerup', 'pointercancel', 'keyup']) q('[data-crop-canvas]').addEventListener(event, autosave);
  window.addEventListener('beforeunload', event => {
    if (busy || (persistenceFailed && (state.team.length || hasPerson()))) { event.preventDefault(); event.returnValue = ''; }
  });
  function lock(value) {
    busy = value;
    for (const el of form.querySelectorAll('input,select,button')) el.disabled = value || state.attempted;
    submit.disabled = value;
    submit.textContent = value ? t.working : t.checkout;
  }
  function renderList() {
    const list = q('[data-team-list]');
    list.replaceChildren();
    q('[data-team-count]').textContent = state.team.length ? `${state.team.length} ${t.count}` : t.empty;
    for (const member of state.team) {
      const li = document.createElement('li');
      const image = document.createElement('img');
      image.src = member.preview;
      image.alt = member.display;
      image.width = 64; image.height = 102;
      const details = document.createElement('div');
      const name = document.createElement('strong'); name.textContent = member.display;
      const info = document.createElement('span'); info.textContent = `${member.props['properties[Technician Title]']} · ${member.props['properties[Badge Style]']}`;
      details.append(name, info);
      const actions = document.createElement('div');
      const edit = document.createElement('button'); edit.type = 'button'; edit.textContent = t.edit; edit.disabled = busy || state.attempted;
      edit.onclick = () => editMember(member.id).catch(error => setStatus(error.message || t.image_error));
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = t.remove; remove.disabled = busy || state.attempted;
      remove.onclick = async () => {
        state.team = state.team.filter(item => item.id !== member.id);
        if (state.editing === member.id) resetPerson();
        renderList(); await persist();
      };
      actions.append(edit, remove); li.append(image, details, actions); list.append(li);
    }
    add.textContent = state.editing ? t.save_edit : t.add;
  }
  function resetPerson() {
    state.editing = null;
    personal.forEach(el => { el.value = ''; notifyInput(el); });
    setFile(photo, null);
    add.textContent = t.add;
  }
  async function restoreForm(record) {
    if (!record) return;
    const sameProduct = String(record.variant) === productVariant;
    const shared = ['properties[Company Name]', 'properties[Google Review Link]', 'properties[Logo Size]'];
    for (const [name, value] of Object.entries(record.props || {})) {
      if (name === 'properties[Badge Style]' || (!sameProduct && !shared.includes(name))) continue;
      const input = form.elements.namedItem(name);
      if (input && input.type !== 'file') input.value = value;
    }
    updateStyle();
    style.dispatchEvent(new Event('change', { bubbles: true }));
    setFile(logo, record.logo); setFile(photo, sameProduct ? record.photo : null);
    personal.forEach(notifyInput); notifyInput(q('[data-logo-size]')); notifyInput(review);
    await form.revvyRestoreCrop(sameProduct ? record.crop : null);
    await new Promise(resolve => setTimeout(resolve, 0));
  }
  async function captureMember() {
    if (!form.reportValidity()) return null;
    const change = revision;
    const record = snapshot();
    const cropped = await form.revvyPreparePhoto();
    const logoUrl = URL.createObjectURL(record.logo);
    const photoUrl = URL.createObjectURL(cropped);
    try {
      const [l, p] = await Promise.all([window.RevvyStyles.load(logoUrl), window.RevvyStyles.load(photoUrl)]);
      if (revision !== change) throw new Error(t.image_error);
      const display = record.props['properties[Badge Display Name]'] || [record.props['properties[First Name]'], record.props['properties[Last Name]']].filter(Boolean).join(' ');
      const canvas = document.createElement('canvas');
      window.RevvyStyles.draw(canvas, { design: style.value, photo: p, logo: l, logoSize: record.props['properties[Logo Size]'], name: display, role: record.props['properties[Technician Title]'] });
      return { ...record, id: state.editing || uid(), cropped, display, preview: canvas.toDataURL('image/png') };
    } finally { URL.revokeObjectURL(logoUrl); URL.revokeObjectURL(photoUrl); }
  }
  async function saveMember() {
    const member = await captureMember();
    if (!member) return false;
    const index = state.team.findIndex(item => item.id === member.id);
    if (index < 0) state.team.push(member); else state.team[index] = member;
    resetPerson(); renderList(); await persist(); return true;
  }
  async function editMember(id) {
    if (busy || state.attempted) return;
    if (hasPerson() && !await saveMember()) return;
    const member = state.team.find(item => item.id === id);
    if (!member) return;
    if (String(member.variant) !== productVariant) {
      const handles = {Classic:'revvy-nfc-review-badge','Round Portrait':'revvytag-round-portrait-nfc-review-badge',Diagonal:'revvytag-diagonal-nfc-review-badge','Soft Arch':'revvytag-soft-arch-nfc-review-badge'};
      const destination = member.productUrl || `${cartRoot}products/${handles[member.props['properties[Badge Style]']] || handles.Classic}`;
      state.editing = id;
      await persist(member);
      window.location.assign(destination);
      return;
    }
    restoring = true;
    try { await restoreForm(member); state.editing = id; }
    finally { restoring = false; }
    renderList(); setStatus(`${t.editing}: ${member.display}`); await persist();
    personal[0].focus(); form.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }
  add.addEventListener('click', async () => {
    if (busy || state.attempted) return;
    busy = true; add.disabled = true; submit.disabled = true;
    try { if (await saveMember()) { setStatus(t.badge_added); personal[0].focus(); } }
    catch (error) { setStatus(error.message || t.image_error); }
    finally { busy = false; add.disabled = false; submit.disabled = false; renderList(); }
  });
  q('[data-team-cancel]').addEventListener('click', async () => { if(busy || state.attempted) return; resetPerson(); renderList(); setStatus(''); await persist(); });
  q('[data-team-clear]').addEventListener('click', async () => {
    if (busy || state.attempted || !window.confirm(t.confirm_clear)) return;
    clearTimeout(timer); state = { version: 1, team: [], current: null, editing: null, attempted: false };
    form.reset(); setFile(logo, null); resetPerson(); updateStyle(); notifyInput(review); notifyInput(q('[data-logo-size]'));
    renderList(); await persist(); setStatus('');
  });
  const getCart = async () => {
    const response = await fetch(`${cartRoot}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error(t.failure);
    return response.json();
  };
  const changeLine = async (key, quantity) => {
    const response = await fetch(`${cartRoot}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
    if (!response.ok) throw new Error(t.failure);
  };
  async function membership() {
    const response = await fetch(`${cartRoot}apps/revvy`, { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (response.status === 401 || response.status === 404) return false;
    if (!response.ok) throw new Error(t.failure);
    const data = await response.json();
    return ['active', 'trialing'].includes(String(data.subscription?.status || '').toLowerCase());
  }
  async function reconcileMember(cart, member) {
    const found = cart.items.filter(item => item.properties?._RevvyTeamBadge === member.id);
    if (!found.length) return false;
    for (const item of found.slice(1)) await changeLine(item.key, 0);
    if (found[0].quantity !== 1) await changeLine(found[0].key, 1);
    return true;
  }
  async function addMemberToCart(member) {
    let cart = await getCart();
    if (await reconcileMember(cart, member)) return;
    const body = new FormData(); body.set('id', member.variant); body.set('quantity', '1');
    for (const [name, value] of Object.entries(member.props)) body.set(name, value);
    body.set('properties[Company Logo]', member.logo, member.logo.name || 'company-logo.png');
    body.set('properties[Technician Photo]', member.cropped, 'technician-photo-cropped.jpg');
    body.set('properties[_RevvyTeamBadge]', member.id);
    const response = await fetch(`${cartRoot}cart/add.js`, { method: 'POST', body, headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(t.failure);
    cart = await getCart();
    if (!await reconcileMember(cart, member)) throw new Error(t.failure);
  }
  form.addEventListener('submit', async event => {
    event.preventDefault(); if (busy || restoring) return;
    clearTimeout(timer);
    busy = true; add.disabled = true; submit.disabled = true;
    try {
      if (!state.attempted && (hasPerson() || state.editing)) { if (!await saveMember()) return; }
      if (!state.team.length && !state.attempted) { setStatus(t.empty_checkout); return; }
      await persist();
      state.attempted = true; await persist(); lock(true); renderList(); setStatus(t.working);
      const active = await membership();
      while (state.team.length) {
        await addMemberToCart(state.team[0]);
        state.team.shift();
        await persist(); renderList();
      }
      const cart = await getCart();
      const memberships = cart.items.filter(item => Number(item.variant_id) === 50345874096368);
      if (active) { for (const item of memberships) await changeLine(item.key, 0); }
      else if (memberships.length) {
        for (const item of memberships.slice(1)) await changeLine(item.key, 0);
        if (memberships[0].quantity !== 1) await changeLine(memberships[0].key, 1);
      }
      state.attempted = false;
      await persist();
      window.location.assign(`${cartRoot}cart`);
    } catch (error) { setStatus(`${t.failure} ${state.attempted ? t.locked : ''}`); }
    finally { lock(false); renderList(); }
  });
  (async () => {
    lock(true); setStatus(t.loading);
    try {
      db = await openDatabase();
      const saved = await storage('get');
      if (saved?.version === 1 && Array.isArray(saved.team)) {
        state = saved; if (String(state.current?.variant) !== productVariant) state.editing = null; await restoreForm(state.current); setStatus(state.attempted ? t.failure : t.restored);
      } else setStatus('');
    } catch (error) { persistenceFailed = true; storageStatus.textContent = t.storage_error; setStatus(''); }
    finally { restoring = false; lock(false); renderList(); }
  })();
})();

